import {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

export enum OngoingABTests {
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    PROPERTY_SHOW_BUTTONS = "PROPERTY_SHOW_BUTTONS"
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    {
        id: "g12399203am7ou0ulmks",
        expires: new Date(2026, 2, 31),
        name: OngoingABTests.PROPERTY_SHOW_BUTTONS,
        path: [],
        matchOnAllPaths: true,
        variants: 1,
        withSSR: false
    }
];
import {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

export enum OngoingABTests {
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    PROPERTY_SHOW_BUTTONS = "PROPERTY_SHOW_BUTTONS"
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    {
        id: "g12399203am7ou0ulmks",
        expires: new Date(2026, 2, 31),
        name: OngoingABTests.PROPERTY_SHOW_BUTTONS,
        path: [],
        matchOnAllPaths: true,
        variants: 1,
        withSSR: false
    }
];
